module.exports = __webpack_public_path__ + "static/media/FrutigerNeueLTW04-Black.03a6cbd1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/frutiger/FrutigerNeueLTW04-Black.ttf
// module id = 643
// module chunks = 0